/**
 * /devhub/runtime — Area A2 (Runtime Control). REQ-001.91 DevHub UI rebuild · Phase 1 IA shell.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DevHubAreaShell } from '../components/devhub/DevHubAreaShell';

export const Route = createFileRoute('/devhub/runtime')({ component: DevHubRuntime });

function DevHubRuntime() {
  return (
    <DevHubAreaShell
      title="Runtime Control"
      subtitle="Turn the local guardrail + chat worker on/off through the local runtime bridge."
      pages={[
        {
          label: 'Runtime control (on/off + timer)',
          description:
            'Turn the guardrail + execution worker on/off through the local runtime bridge, with an auto-off timer and honest disabled states when deployed.',
          status: 'live',
          to: '/devhub/runtime-control',
        },
        {
          label: 'Workers',
          description: 'Local worker runtime registry — registration vs live process status.',
          status: 'live',
          to: '/devhub/workers',
        },
        {
          label: 'Guardrail — idl-localserver',
          description: 'Turn On/Off; desired vs observed at 127.0.0.1:8787 (the grounding seam).',
          status: 'Phase 3',
        },
        {
          label: 'Chat worker — rag_chat_worker',
          description: 'Turn On/Off; registration vs live process; deny-by-default prerequisite.',
          status: 'Phase 3',
        },
      ]}
    />
  );
}
